export default "<img src=\"{{logo}}\" alt=\"\" />"